import { useState } from 'react'
import styled from 'styled-components'
import Button from 'components/Button'
import cookie from 'assets/cookie.svg'
import copy from 'copy.json'

const text = copy.cookie_policy

const getCookieBannerVisibliity = () => {
  if (typeof window === 'undefined') return false
  const cookieBannerVisibility = localStorage.getItem('cookieBannerVisibility')
  return cookieBannerVisibility === null ? true : cookieBannerVisibility === 'true'
}

export default function CookiePolicyBanner() {
  const [isVisible, setIsVisible] = useState(getCookieBannerVisibliity())

  const handleAccept = () => {
    localStorage.setItem('cookieBannerVisibility', 'false')
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <Wrapper>
      <Text>
        <Header>
          <img src={cookie} alt="" />
          <h2>{text.heading}</h2>
        </Header>

        <p>{text.text}</p>
      </Text>

      <Buttons>
        <Button onClick={handleAccept}>{text.button}</Button>
        <a
          href="http://static.ozeos.pl/legal/polityka_cookies_latest.pdf"
          download
          target="_blank"
          rel="noreferrer"
        >
          {text.link}
        </a>
      </Buttons>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 17px max(8px, calc((100% - 1312px) / 2));
  background: var(--white);
  box-shadow: 0 -5px 10px rgba(0, 0, 0, 0.1);

  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 10;

  @media (min-width: 769px) {
    flex-direction: row;
    gap: 40px;
  }
`

const Header = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

const Text = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;

  h2 {
    font: var(--400-15);
  }

  @media (min-width: 769px) {
    h2 {
      font: var(--600-24);
    }

    img {
      width: 32px;
    }
  }
`

const Buttons = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    > * {
      flex: 1;
    }
  }

  @media (min-width: 769px) {
    flex: 1 0 300px;
    flex-direction: column;
  }

  a {
    font: var(--400-13);
    color: var(--green);
    text-align: center;

    :hover {
      text-decoration: underline;
    }
  }
`
